// export const BASE_API = "http://localhost:6002/api";
export const BASE_API =
  "https://aiphotobooth.collab.exchange/HyundaiBackendServerapi";
